import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { computed, onMounted, ref } from 'vue';
import { EnterCodeVariant, IJoinRewardsStep, ILinkRewardsUser, ISendCodeResponse, IVerifyUserData, RewardsReasonCode } from 'JS/types/rewards';
import { objectToQueryString } from 'JS/utilities/url';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserVerification',
  props: {
    verificationData: null
  },
  emits: ["go-to-enter-code", "switch-page", "loading"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'go-to-enter-code', variant: EnterCodeVariant, redactedString?: string, rewardsSessionId?: string): void;
	(e: 'switch-page', page: IJoinRewardsStep): void;
	(e: 'loading', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	verificationData: IVerifyUserData;
}





const { rewardsService } = useServices();

const errorMessage = ref<string>("");
const headerFocuser = ref<HTMLElement | null>(null);

const headerText = computed(()=> {
	if (props.verificationData.variant === 'verification-join' || props.verificationData.variant === 'verification-account') return "Connect Rewards Account";
	if (props.verificationData.variant === 'verification-connect') return "Identity Verification";
	return "This rewards account is already associated with another user";
});

const subtitleText = computed(()=> {
	if (props.verificationData.variant === 'verification-join' || props.verificationData.variant === 'verification-account')
		return "Looks like you previously joined Blain’s Rewards in store! To connect your account, choose a verification method.";
	if (props.verificationData.variant === 'verification-connect')
		return "We found a matching account. How would you like to receive your verification code?";
	return "Try logging in with the email below instead!";
});

const logoutLink = computed((): string => {
	const loginLink = `/account/login/?${objectToQueryString({
		refUrl: window?.location.pathname,
	})}`;

	return `/account/logout/?${objectToQueryString({
		refUrl: loginLink,
	})}`;
});

async function sendCode(method: 'phone' | 'email') {
	emit('loading', true);
	const userRewardsData: ILinkRewardsUser = {
		phoneNumber: props.verificationData.redactedData == 'email' ? props.verificationData.phone : null,
		email: props.verificationData.redactedData == 'phone' ? props.verificationData.email : null,
		rewardsNumber: props.verificationData.redactedData == 'both' ? props.verificationData.rewardsNumber : null,
		verificationMethod: method,
	};
	const results: ISendCodeResponse = await rewardsService.sendVerificationCode(userRewardsData);
	if (!results.success) {
		if (results.reasonCode === RewardsReasonCode.CUSTOMER_HAS_REWARDS) {
			emit('switch-page', 'customer-has-rewards');
		} else {
			errorMessage.value = results.errorMessage;
		}
	}  else {
		if (method === 'phone') {
			emit('go-to-enter-code', method, props.verificationData.phone, results.rewardsSessionId );
		} else {
			emit('go-to-enter-code', method, props.verificationData.email, results.rewardsSessionId );
		}
	}
	emit('loading', false);
}

function handleCantRecieveCode() {
	if (props.verificationData.rewardsNumber) {
		emit('switch-page', 'help');
	} else {
		emit('go-to-enter-code', 'rewards-number');
	}
}

onMounted(()=> {
	headerFocuser.value?.focus();
});

return { __sfc: true,props, emit, rewardsService, errorMessage, headerFocuser, headerText, subtitleText, logoutLink, sendCode, handleCantRecieveCode, BButton, ErrorBanner, LinkButton }
}

})